import React, { useEffect } from "react";
import styled from "styled-components";
import { HeaderIcon, UtilityHeader } from "../../components/Header";
import { MdShoppingCart, MdHistory } from "react-icons/md";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getCart,
  getCartId,
  getHistory, getLoaded, getLoading,
} from "../../reducers/project/selectors";
import erkado from "../../assets/logo/erkado.png";
import { Desktop } from "../../components/Responsive";

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 61px;
  padding-left: 40px;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 26px;
`;

const HeaderLabel = styled.div`
font-weight: 600;
font-size: 16px;
line-height: 20px;

letter-spacing: -0.01em;

color: #C41230;
opacity: 0.8;
`

function Header({}: IHeader) {
  const history = useSelector(getHistory);
  const cart = useSelector(getCart);
  const cartId = useSelector(getCartId);
  const loaded = useSelector(getLoading)

  useEffect(() => {
    if (history.length !== 0) {
      window.localStorage.setItem("history", JSON.stringify(history));
    }
  }, [history]);

  useEffect(() => {
    if (cartId) {
      window.localStorage.setItem("cart", cartId);
    }
  }, [cartId]);

  return (
    <>
      {/*<Desktop>*/}
      {/*  <UtilityHeader />*/}
      {/*</Desktop>*/}

      <HeaderWrapper>
        <div style={{display: 'flex'}}>
          {/*<Link to={"/"}>*/}
          {/*  <img src={erkado} />*/}
          {/*</Link>*/}
          <Desktop>
          {/*<div style={{border: '1px solid #EAE5E5', height:'22px', margin: '0px 24px'}}/>*/}
          <HeaderLabel>KONFIGURATOR DRZWI</HeaderLabel>
          </Desktop>
        </div>
        {!loaded && <><div style={{ display: "flex" }}>
          <Link to={"/history"}>
            <HeaderIcon count={history.length} Icon={<MdHistory size={25} />} />
          </Link>
          <Link to={"/cart"}>
            <HeaderIcon
              count={cart.length}
              Icon={<MdShoppingCart size={25} />}
            />
          </Link>
        </div>
        </>}
      </HeaderWrapper>
    </>
  );
}

export interface IHeader {}

export default Header;
